(() => {
  const initializeWatchCarousel = (section) => {
    const carousel = section.querySelector('[data-watch-carousel]');
    const previous = section.querySelector('[data-watch-previous]');
    const next = section.querySelector('[data-watch-next]');

    if (!carousel || !previous || !next) return;

    const updateArrows = () => {
      const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
      previous.disabled = carousel.scrollLeft <= 5;
      next.disabled = carousel.scrollLeft >= maxScrollLeft - 5;
    };

    const scrollCarousel = (direction) => {
      const card = carousel.querySelector('.watch-rvertv__card');
      if (!card) return;

      const gap = Number.parseFloat(getComputedStyle(carousel).gap) || 20;
      carousel.scrollBy({
        behavior: 'smooth',
        left: (card.offsetWidth + gap) * direction,
      });
    };

    previous.addEventListener('click', () => scrollCarousel(-1));
    next.addEventListener('click', () => scrollCarousel(1));
    carousel.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  };

  const initialize = () => {
    document.querySelectorAll('[data-watch-rvertv]').forEach(initializeWatchCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('[data-watch-rvertv]');
    if (section) initializeWatchCarousel(section);
  });
})();
